import { httpsCallable } from "firebase/functions"
import { functions } from "../../firebase"

export async function sendNotification(content) {
    const notification = httpsCallable(functions, "sendNotification")
    notification(content).then((res) => {
    })
  }